var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoUser(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.097,
    height: 28.097,
    viewBox: "0 0 28.097 28.097",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 14",
    d: "M32.9 32.291h-2.008v-5.017a5.024 5.024 0 0 0-5.017-5.017V20.25a7.032 7.032 0 0 1 7.025 7.024z",
    transform: "translate(-4.802 -4.195)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 15",
    d: "M22.319 32.291h-2.007v-5.017a5.024 5.024 0 0 0-5.017-5.017H9.274a5.024 5.024 0 0 0-5.017 5.017v5.017H2.25v-5.017a7.032 7.032 0 0 1 7.024-7.024h6.021a7.032 7.032 0 0 1 7.024 7.024z",
    transform: "translate(-2.25 -4.195)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 16",
    d: "M22.5 2.25v2.007a5.017 5.017 0 0 1 0 10.035V16.3a7.024 7.024 0 1 0 0-14.048z",
    transform: "translate(-4.438 -2.25)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 17",
    d: "M12.649 4.257a5.017 5.017 0 1 1-5.017 5.017 5.017 5.017 0 0 1 5.017-5.017m0-2.007a7.024 7.024 0 1 0 7.024 7.024 7.024 7.024 0 0 0-7.024-7.024z",
    transform: "translate(-2.615 -2.25)",
    style: {
      fill: "#fff"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoUser);
export default __webpack_public_path__ + "static/media/ico-user.9491e2825ad281f97fd7974c57252ea4.svg";
export { ForwardRef as ReactComponent };